export default "__VITE_ASSET__Be_Au38d__"